module.exports = __webpack_public_path__ + "static/media/elo.9608788f.png";